var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "opt_g2" }, [
    _c(
      "div",
      {
        class: { opt_open: this.openedLayer === "starJoin" },
        attrs: { id: "optStars" },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.openLayer.apply(null, arguments)
          },
        },
      },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.openedLayer === "starJoin",
            expression: "openedLayer === 'starJoin'",
          },
        ],
        staticClass: "opt_layer",
        attrs: { id: "optStars_layer" },
        on: {
          click: function ($event) {
            $event.stopPropagation()
          },
        },
      },
      [
        _c("div", { staticClass: "search_stars" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.starSearchQuery,
                expression: "starSearchQuery",
              },
            ],
            ref: "search",
            staticClass: "tf_stars",
            attrs: {
              type: "text",
              id: "searchStar",
              placeholder: "스타명을 검색해보세요",
              autocomplete: "off",
              maxlength: "15",
            },
            domProps: { value: _vm.starSearchQuery },
            on: {
              keydown: _vm.searchStar,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.starSearchQuery = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn_search ico_cafetop",
              attrs: { id: "searchStarBtn" },
              on: { click: _vm.searchStar },
            },
            [_vm._v("검색")]
          ),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "tab_stars" }, [
          _c(
            "li",
            {
              class: { on: _vm.category === "all" },
              attrs: { id: "starJoinCafeCate_all" },
              on: { click: _vm.setCategory },
            },
            [_c("span", { staticClass: "link_tab" }, [_vm._v("전체")])]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { on: _vm.category === "musician" },
              attrs: { id: "starJoinCafeCate_musician" },
              on: { click: _vm.setCategory },
            },
            [_c("span", { staticClass: "link_tab" }, [_vm._v("가수")])]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { on: _vm.category === "actor" },
              attrs: { id: "starJoinCafeCate_actor" },
              on: { click: _vm.setCategory },
            },
            [_c("span", { staticClass: "link_tab" }, [_vm._v("배우")])]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { on: _vm.category === "sportsman" },
              attrs: { id: "starJoinCafeCate_sportsman" },
              on: { click: _vm.setCategory },
            },
            [_c("span", { staticClass: "link_tab" }, [_vm._v("스포츠")])]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { on: _vm.category === "entertainer" },
              attrs: { id: "starJoinCafeCate_entertainer" },
              on: { click: _vm.setCategory },
            },
            [_c("span", { staticClass: "link_tab" }, [_vm._v("방송인")])]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { on: _vm.category === "etc" },
              attrs: { id: "starJoinCafeCate_etc" },
              on: { click: _vm.setCategory },
            },
            [_c("span", { staticClass: "link_tab" }, [_vm._v("기타")])]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "starJoinList",
            staticClass: "box_stars",
            attrs: { id: "starJoinCafeList" },
            on: { scroll: _vm.loadMoreStarJoin },
          },
          [
            _c(
              "ul",
              { staticClass: "list_stars" },
              [
                _vm._l(_vm.fancafeList, function (fancafe, index) {
                  return _c(
                    "star-join-item",
                    _vm._b(
                      { key: "star-join-" + index },
                      "star-join-item",
                      fancafe,
                      false
                    )
                  )
                }),
                _vm._v(" "),
                _vm.fancafeList.length === 0
                  ? _c("li", [
                      _c("div", { staticClass: "group_noresult" }, [
                        _c("div", { staticClass: "ico_cafetop ico_result" }, [
                          _vm._v("검색결과"),
                        ]),
                        _vm._v(" "),
                        _c("em", [_vm._v(_vm._s(_vm.resultText))]),
                        _vm._v("에 대한 "),
                        _c("br"),
                        _vm._v(
                          "\n                        검색 결과가 없습니다.\n                    "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "opt_selected" }, [
      _c("span", { staticClass: "tf_opt" }, [
        _c("span", { staticClass: "txt_selected" }, [
          _vm._v("스타가 가입한 팬카페"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "ico_cafetop ico_arrow" }, [
          _vm._v("옵션 더 보기"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }